import { Layout } from '@/components/layout/Layout';
import { VideoHero } from '@/components/home/VideoHero';
import { ServiceSection } from '@/components/home/ServiceSection';
import { GiftCardSection } from '@/components/home/GiftCardSection';
import { FloatingElements } from '@/components/home/FloatingElements';
import { useHomepageSections } from '@/hooks/useSiteData';
import { Seo } from "@/components/Seo";

const Index = () => {
  const { data: sections } = useHomepageSections();

  // Filter service sections (not hero or gift_card)
  const serviceSections = sections?.filter(
    s => !['hero', 'gift_card'].includes(s.section_key)
  ) || [];

  return (
    <Layout>
      <Seo
        title={"Karmaio — Massaggi, Tantra e Benessere Olistico a Milano"}
        description={"Centro Karmaio a Milano: massaggi olistici, percorsi tantra, corsi e gift card. Prenota online il tuo trattamento di benessere."}
        path="/"
        jsonLd={[
          {
            "@context": "https://schema.org",
            "@type": "LocalBusiness",
            "@id": "https://karmaio.it/#business",
            name: "Karmaio",
            description: "Centro olistico a Milano: massaggi, tantra, corsi ed eventi di benessere.",
            url: "https://karmaio.it/",
            telephone: "+39 333 0000000",
            image: "https://karmaio.it/og-image.jpg",
            address: {
              "@type": "PostalAddress",
              addressLocality: "Milano",
              addressRegion: "MI",
              addressCountry: "IT",
            },
            priceRange: "€€",
            areaServed: "Milano",
          },
          {
            "@context": "https://schema.org",
            "@type": "WebSite",
            url: "https://karmaio.it/",
            name: "Karmaio",
            inLanguage: "it-IT",
          },
        ]}
      />

      {/* Floating decorative elements with parallax */}
      <FloatingElements />
      
      <VideoHero />

      
      {serviceSections.map((section, index) => (
        <ServiceSection 
          key={section.id} 
          section={section} 
          reverse={index % 2 === 1}
        />
      ))}

      <GiftCardSection />
    </Layout>
  );
};

export default Index;

